import { render, staticRenderFns } from "./ProductAddToWishlistButton.vue?vue&type=template&id=26aadc2e&scoped=true&"
import script from "./ProductAddToWishlistButton.vue?vue&type=script&lang=js&"
export * from "./ProductAddToWishlistButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddToWishlistButton.vue?vue&type=style&index=0&id=26aadc2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aadc2e",
  null
  
)

export default component.exports